import type { ReactNode } from 'react'

import { Link, Skeleton } from '@/components/ui'
const isDevelopment = import.meta.env.DEV

import { cx } from '../../ui/utils'
import BreakpointIndicator from '../BreakpointIndicator'

enum FooterVariationStyle {
  center = 'center',
}

export interface FooterLinkType {
  key: string
  label: string
  url: string
}

export interface FooterProps {
  links?: FooterLinkType[]
  variation?: keyof typeof FooterVariationStyle
  /** Shown first, at the left: the app shell puts the profile menu and full screen here. */
  leading?: ReactNode
}

export const BASE_CONTENT = `${new Date().getFullYear()} © Cooltrax`

export const Fallback = () => (
  <div>
    <Skeleton shouldRemoveCurvedBorder />
  </div>
)

export default function Footer({ variation, links = [], leading }: FooterProps) {
  return (
    <footer
      className={cx(
        'footer items-center p-2 text-gray-400',
        variation === FooterVariationStyle.center && 'justify-center'
      )}
    >
      {variation === FooterVariationStyle.center ? (
        <span className="footer-center">{BASE_CONTENT}</span>
      ) : (
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-4">
            {leading}
            {Boolean(links?.length) && (
              <section aria-label="footer links" className="text-md footer-links flex gap-6">
                {links?.map(({ key, label, url }) => (
                  <Link key={key} href={url}>
                    {label}
                  </Link>
                ))}
              </section>
            )}
          </div>
          <div className="flex items-center gap-4">
            {isDevelopment && <BreakpointIndicator />}
            <span>{BASE_CONTENT}</span>
          </div>
        </div>
      )}
    </footer>
  )
}
